



































import {Vue, Component } from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'NewsTile',
  components: {
    VLazyImage,
  },
  props: {
    news: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    promoText: {
      type: String,
      default: '',
    },
  },
  methods: {
    srcImg(img) {
      return img && `${img[3600]}` || '';
    },

    srcImgPlaceholder(img) {
      return img && `${img[400]}`;
    },

    srcSet(img) {
      return img && `${img[400]} 400w, ${img[800]} 800w,
      ${img[1300]} 1300w, ${img[1900]} 1900w, ${img[3600]} 3600w`;
    },
  },
})
export default class NewsTile extends Vue {}
